export const UNITS = {
  SI: "International (SI)",
  US: "Imperial (US)",
} as const;
